var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.RosterRecordTitle === null
    ? _c("noContent")
    : _c("ContentLayout", {
        attrs: {
          widthClass: " min-1200",
          backgroundClass: "transparent",
          pad: "0",
          delBtn: _vm.hasBtn("delete-admin-roster-form-record"),
          initData: _vm.RosterRecordData,
          checkData: [
            "roster_form_record_title",
            "roster_form_record_description",
            "remarks",
          ],
          editBtn:
            !_vm.iSEdited &&
            _vm.RosterRecordData &&
            _vm.RosterRecordData.status_uuid === "Draft" &&
            _vm.hasBtn("edit-admin-roster-form-record"),
          title: _vm.RosterRecordTitle,
        },
        on: {
          change: function (changed) {
            return (_vm.isChanged = changed)
          },
          delete: function ($event) {
            _vm
              .$confirmDo(
                _vm.$t("label_essweb_admin_RosterFormRecord_list_title")
              )
              .then(function (res) {
                res ? _vm.toDeleteRecord() : null
              })
          },
          edit: function ($event) {
            _vm.iSEdited = true
          },
        },
        scopedSlots: _vm._u([
          {
            key: "appendTitle",
            fn: function () {
              return [
                _c("StatusChip", {
                  attrs: {
                    icon: "",
                    "content-class": "mx-2",
                    slideColor: _vm.RosterRecordData.approval_tint_color,
                    bgColor: _vm.RosterRecordData.approval_bg_color,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "status",
                      fn: function () {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getCommonLangValue(
                                  _vm.RosterRecordData.status_detail
                                )
                              ) +
                              " "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      icon: "",
                      small: "",
                      color:
                        Number(_vm.RosterRecordData.is_locked) == 1
                          ? "text--primary"
                          : "text--secondary text--lighten-1",
                    },
                  },
                  [
                    _c(
                      "i",
                      {
                        staticClass: "material-icons-round md-18 mt-1",
                        attrs: { left: "" },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            Number(_vm.RosterRecordData.is_locked) == 1
                              ? "lock"
                              : "lock_open"
                          )
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "nav-actions",
            fn: function () {
              return [
                _vm.curTab == "tab-2"
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "primary mr-4",
                        attrs: {
                          icon: "",
                          color: "white",
                          width: "40",
                          height: "40",
                        },
                        on: {
                          click: function ($event) {
                            _vm
                              .$confirmWarn(
                                _vm.$t(
                                  "label_essweb_RosterRecord_list_exportOutBtnLabel"
                                ),
                                _vm.$t(
                                  "message_essweb_system_operation_export_outLabel"
                                ),
                                null,
                                _vm.$t(
                                  "message_essweb_system_operation_export_exportOutLabel"
                                )
                              )
                              .then(function (res) {
                                if (res) {
                                  _vm.showExportOut = true
                                }
                              })
                          },
                        },
                      },
                      [
                        _c("svg-icon", {
                          attrs: { size: "24", iconClass: "export" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                !Number(_vm.RosterRecordData.is_submitted) &&
                _vm.curTab == "tab-2"
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "primary mr-4",
                        attrs: {
                          icon: "",
                          color: "white",
                          width: "40",
                          height: "40",
                        },
                        on: {
                          click: function ($event) {
                            _vm.showExportIn = !_vm.showExportIn
                          },
                        },
                      },
                      [
                        _c("svg-icon", {
                          attrs: { size: "24", iconClass: "import" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            !Number(_vm.RosterRecordData.is_locked) == 1 &&
                            _vm.curStep != 3
                              ? _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "mr-4 text-capitalize",
                                        class:
                                          !_vm.RosterRecordData.status_uuid ||
                                          _vm.RosterRecordData.status_uuid ==
                                            "Publishing" ||
                                          _vm.RosterRecordData.status_uuid ==
                                            "Submiting" ||
                                          _vm.loading
                                            ? "grey"
                                            : "primary",
                                        attrs: {
                                          color: "white",
                                          disabled:
                                            !_vm.RosterRecordData.status_uuid ||
                                            _vm.RosterRecordData.status_uuid ==
                                              "Publishing" ||
                                            _vm.RosterRecordData.status_uuid ==
                                              "Submiting" ||
                                            _vm.loading,
                                          icon: "",
                                          width: "40",
                                          loading: _vm.loading,
                                          height: "40",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.toStep(_vm.curStep)
                                          },
                                        },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons-round" },
                                      [_vm._v("send")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.curStep == 0
                            ? _vm.$t(
                                "label_essweb_RosterFormRecord_form_draftLabel"
                              )
                            : _vm.curStep == 1
                            ? _vm.$t(
                                "label_essweb_RosterFormRecord_form_publicLabel"
                              )
                            : _vm.curStep == 2
                            ? _vm.$t(
                                "label_essweb_RosterFormRecord_form_submitLabel"
                              )
                            : ""
                        ) +
                        " "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "page-main",
            fn: function () {
              return [
                false
                  ? _c(
                      "v-container",
                      { staticClass: "d-flex", attrs: { fluid: "" } },
                      [
                        _c("v-spacer"),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            staticClass: "primary mr-2",
                                            attrs: {
                                              icon: "",
                                              color: "white",
                                              width: "40",
                                              height: "40",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                _vm
                                                  .$confirmDo(
                                                    _vm.$t(
                                                      "label_essweb_admin_RosterFormRecord_list_title"
                                                    )
                                                  )
                                                  .then(function (res) {
                                                    res
                                                      ? _vm.toDeleteRecord()
                                                      : null
                                                  })
                                              },
                                            },
                                          },
                                          on
                                        ),
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "material-icons-round",
                                            },
                                            [_vm._v("delete")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4126224603
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message_essweb_list_components_tools_delBtnTip"
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !_vm.iSEdited,
                                                expression: "!iSEdited",
                                              },
                                            ],
                                            staticClass: "primary mr-2",
                                            attrs: {
                                              icon: "",
                                              color: "white",
                                              width: "40",
                                              height: "40",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                _vm.iSEdited = true
                                              },
                                            },
                                          },
                                          on
                                        ),
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "material-icons-round",
                                            },
                                            [_vm._v("edit")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2255887302
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message_essweb_list_components_tools_editBtnTip"
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("Taber", {
                  attrs: {
                    curTab: _vm.curTab,
                    items: _vm.taber,
                    special: "",
                    contentBackground: "mrc-grey pa-0",
                  },
                  on: {
                    change: function (tab) {
                      return (_vm.curTab = tab)
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "content-1",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "max-width rounded-lg transparent" },
                            [
                              _c(
                                "v-tabs",
                                {
                                  staticClass: "mrc-grey",
                                  attrs: {
                                    vertical: "",
                                    "background-color":
                                      "var(--taber-nav-color)",
                                    "hide-slider": "",
                                  },
                                  model: {
                                    value: _vm.lefttab,
                                    callback: function ($$v) {
                                      _vm.lefttab = $$v
                                    },
                                    expression: "lefttab",
                                  },
                                },
                                [
                                  _c("v-sheet", {
                                    staticClass: "rounded-t-lg",
                                    attrs: { height: "8", width: "150" },
                                  }),
                                  _c(
                                    "v-tab",
                                    {
                                      staticClass:
                                        "\n                text-capitalize\n                px-3\n                mr-2\n                d-inline-block\n                text-left text--primary\n              ",
                                      class: _vm.lefttab == 0 ? " " : "white ",
                                      staticStyle: {
                                        width: "150px",
                                        "line-height": "48px",
                                      },
                                      style: {
                                        backgroundColor:
                                          _vm.lefttab == 0 ? "#E6F0FF" : "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_RosterFormRecord_form_tab_infoLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-tab",
                                    {
                                      staticClass:
                                        "\n                text-capitalize\n                px-3\n                mr-2\n                d-inline-block\n                text-left text--primary\n              ",
                                      class: _vm.lefttab == 1 ? " " : "white ",
                                      staticStyle: {
                                        width: "150px",
                                        "line-height": "48px",
                                      },
                                      style: {
                                        backgroundColor:
                                          _vm.lefttab == 1 ? "#E6F0FF" : "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_RosterFormRecord_form_tab_detailLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-tab",
                                    {
                                      staticClass:
                                        "\n                text-capitalize\n                px-3\n                mr-2\n                d-inline-block\n                text-left text--primary\n              ",
                                      class: _vm.lefttab == 2 ? " " : "white ",
                                      staticStyle: {
                                        width: "150px",
                                        "line-height": "48px",
                                      },
                                      style: {
                                        backgroundColor:
                                          _vm.lefttab == 2 ? "#E6F0FF" : "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_RosterFormRecord_form_tab_flowLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-sheet", {
                                    staticClass: "rounded-b-lg",
                                    attrs: { height: "8", width: "150" },
                                  }),
                                  _c(
                                    "v-tab-item",
                                    { staticClass: "mrc-grey rounded-lg" },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "mrc-grey rounded-lg",
                                          attrs: { elevation: 0 },
                                        },
                                        [
                                          _c(
                                            "v-card-text",
                                            {
                                              staticClass:
                                                "transparent pa-0 rounded-lg",
                                            },
                                            [
                                              _c(
                                                "v-form",
                                                {
                                                  ref: "form",
                                                  staticClass:
                                                    "white pa-3 fill-height scroll_content",
                                                  class: _vm.iSEdited
                                                    ? "rounded-lg"
                                                    : "rounded-t-lg",
                                                  attrs: {
                                                    "lazy-validation": "",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            xs: "12",
                                                            sm: "12",
                                                            md: "12",
                                                            lg: "12",
                                                            cols: "12",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "normalInputTextFiled",
                                                            {
                                                              attrs: {
                                                                readonly:
                                                                  !_vm.iSEdited,
                                                                filled:
                                                                  _vm.iSEdited,
                                                                label: _vm.$t(
                                                                  "label_essweb_RosterFormRecord_form_rosterNameLabel"
                                                                ),
                                                                rules:
                                                                  _vm.$GetRules(
                                                                    [
                                                                      "_Require_Rules",
                                                                    ],
                                                                    [null]
                                                                  ),
                                                                dense: "",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .RosterRecordData
                                                                    .roster_form_record_title,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.RosterRecordData,
                                                                      "roster_form_record_title",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "RosterRecordData.roster_form_record_title",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            xs: "12",
                                                            sm: "6",
                                                            md: "6",
                                                            lg: "6",
                                                            cols: "12",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-sheet",
                                                            {
                                                              staticClass:
                                                                "text--secondary",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "label_essweb_RosterFormRecord_form_startDateLabel"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              filled: "",
                                                              dense: "",
                                                              disabled: "",
                                                              "single-line": "",
                                                              label: _vm.$t(
                                                                "label_essweb_RosterFormRecord_form_startDateLabel"
                                                              ),
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .RosterRecordData
                                                                  .roster_utc_start_date,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.RosterRecordData,
                                                                    "roster_utc_start_date",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "RosterRecordData.roster_utc_start_date",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            xs: "12",
                                                            sm: "6",
                                                            md: "6",
                                                            lg: "6",
                                                            cols: "12",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-sheet",
                                                            {
                                                              staticClass:
                                                                "text--secondary",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "label_essweb_RosterFormRecord_form_endDateLabel"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              filled: "",
                                                              dense: "",
                                                              disabled: "",
                                                              "single-line": "",
                                                              label: _vm.$t(
                                                                "label_essweb_RosterFormRecord_form_endDateLabel"
                                                              ),
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .RosterRecordData
                                                                  .roster_utc_end_date,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.RosterRecordData,
                                                                    "roster_utc_end_date",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "RosterRecordData.roster_utc_end_date",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            xs: "12",
                                                            sm: "12",
                                                            md: "12",
                                                            lg: "12",
                                                            cols: "12",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "normalInputTextFiled",
                                                            {
                                                              attrs: {
                                                                readonly:
                                                                  !_vm.iSEdited,
                                                                filled:
                                                                  _vm.iSEdited,
                                                                label: _vm.$t(
                                                                  "label_essweb_RosterFormRecord_form_descriptionLabel"
                                                                ),
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .RosterRecordData
                                                                    .roster_form_record_description,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.RosterRecordData,
                                                                      "roster_form_record_description",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "\n                            RosterRecordData.roster_form_record_description\n                          ",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            xs: "12",
                                                            sm: "12",
                                                            md: "12",
                                                            lg: "12",
                                                            cols: "12",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-sheet",
                                                            {
                                                              staticClass:
                                                                "text--secondary",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "label_essweb_RosterFormRecord_form_remarkLabel"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c("v-textarea", {
                                                            attrs: {
                                                              rows: "5",
                                                              "no-resize": "",
                                                              maxlength: "500",
                                                              counter: "500",
                                                              dense: "",
                                                              readonly:
                                                                !_vm.iSEdited,
                                                              filled:
                                                                _vm.iSEdited,
                                                              "single-line": "",
                                                              name: "input-7-4",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .RosterRecordData
                                                                  .remarks,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.RosterRecordData,
                                                                    "remarks",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "RosterRecordData.remarks",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm.iSEdited
                                            ? _c("CardActions", {
                                                attrs: { saveBtn: "" },
                                                on: {
                                                  save: _vm.toSave,
                                                  cancel: function ($event) {
                                                    return _vm.toBack(
                                                      _vm.isChanged
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-tab-item",
                                    { staticClass: "rounded-lg transparent" },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "rounded-lg",
                                          attrs: {
                                            "rounded-lg": "",
                                            elevation: "0",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-card-text",
                                            {
                                              staticClass:
                                                "rounded-lg scroll_content_y",
                                              style: {
                                                maxHeight:
                                                  _vm.$vuetify.breakpoint
                                                    .height -
                                                  251 +
                                                  "px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "title pa-2" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "label_essweb_RosterFormRecord_form_table_managerTitle"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("Tabler", {
                                                attrs: {
                                                  headers: _vm.manageHeaders,
                                                  items: _vm.ManageList,
                                                  border: "",
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "item.staff_name",
                                                    fn: function (ref) {
                                                      var item = ref.item
                                                      return [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            staticClass: "pa-0",
                                                            attrs: {
                                                              dense: "",
                                                              "two-line": "",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-avatar",
                                                              {
                                                                staticClass:
                                                                  "mr-1 my-0 pa-0",
                                                                attrs: {
                                                                  size: "36",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "StaffAvatar",
                                                                  {
                                                                    attrs: {
                                                                      size: "36",
                                                                      src: item
                                                                        .mrbase_sys_staffs
                                                                        .staff_avatar,
                                                                      staff_name:
                                                                        item
                                                                          .mrbase_sys_staffs
                                                                          .preferred_name,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "text--primary",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            item
                                                                              .mrbase_sys_staffs
                                                                              .preferred_name
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "text--secondary text-caption-xs",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              item
                                                                                .mrbase_sys_staffs
                                                                                .staff_code
                                                                            )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  {
                                                                    staticClass:
                                                                      "text--secondary",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            item
                                                                              .mrbase_sys_staffs
                                                                              .mrbase_sys_job_posts
                                                                              .job_post_name
                                                                          ) +
                                                                            " - " +
                                                                            item
                                                                              .mrbase_sys_staffs
                                                                              .mrbase_sys_org_levels
                                                                              .org_level_all
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "item.staff_id",
                                                    fn: function (ref) {
                                                      var item = ref.item
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item
                                                                .mrbase_sys_staffs
                                                                .staff_code
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "item.action",
                                                    fn: function (ref) {
                                                      var item = ref.item
                                                      return [
                                                        _vm.iSEdited
                                                          ? _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  icon: "",
                                                                  small: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onDelete(
                                                                        "manage",
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons-round",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "delete"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                              }),
                                              _c(
                                                "v-sheet",
                                                { staticClass: "px-4" },
                                                [
                                                  _vm.iSEdited
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "text-capitalize",
                                                          attrs: {
                                                            text: "",
                                                            small: "",
                                                            color: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onNew(
                                                                "manage"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "label_essweb_RosterFormRecord_form_table_newManagerBtnLabel"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "material-icons-round",
                                                            },
                                                            [_vm._v("add")]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "title pa-2" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "label_essweb_RosterFormRecord_form_table_staffTitle"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("Tabler", {
                                                attrs: {
                                                  headers: _vm.staffHeaders,
                                                  items: _vm.StaffList,
                                                  border: "",
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "item.staff_name",
                                                    fn: function (ref) {
                                                      var item = ref.item
                                                      return [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            staticClass: "pa-0",
                                                            attrs: {
                                                              dense: "",
                                                              "two-line": "",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-avatar",
                                                              {
                                                                staticClass:
                                                                  "mr-1 my-0 pa-0",
                                                                attrs: {
                                                                  size: "36",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "StaffAvatar",
                                                                  {
                                                                    attrs: {
                                                                      size: "36",
                                                                      src: item
                                                                        .mrbase_sys_staffs
                                                                        .staff_avatar,
                                                                      staff_name:
                                                                        item
                                                                          .mrbase_sys_staffs
                                                                          .preferred_name,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "text--primary",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            item
                                                                              .mrbase_sys_staffs
                                                                              .preferred_name
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "text--secondary text-caption-xs",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              item
                                                                                .mrbase_sys_staffs
                                                                                .staff_code
                                                                            )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  {
                                                                    staticClass:
                                                                      "text--secondary",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            item
                                                                              .mrbase_sys_staffs
                                                                              .mrbase_sys_job_posts
                                                                              .job_post_name
                                                                          ) +
                                                                            " - " +
                                                                            item
                                                                              .mrbase_sys_staffs
                                                                              .mrbase_sys_org_levels
                                                                              .org_level_all
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "item.staff_id",
                                                    fn: function (ref) {
                                                      var item = ref.item
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item
                                                                .mrbase_sys_staffs
                                                                .staff_code
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "item.action",
                                                    fn: function (ref) {
                                                      var item = ref.item
                                                      return [
                                                        _vm.iSEdited
                                                          ? _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  icon: "",
                                                                  small: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onDelete(
                                                                        "staff",
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons-round",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "delete"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                              }),
                                              _c(
                                                "v-sheet",
                                                { staticClass: "px-4" },
                                                [
                                                  _vm.iSEdited
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "text-capitalize",
                                                          attrs: {
                                                            text: "",
                                                            small: "",
                                                            color: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onNew(
                                                                "staff"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "label_essweb_RosterFormRecord_form_table_newStaffLabel"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "material-icons-round",
                                                            },
                                                            [_vm._v("add")]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "title pa-2" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "label_essweb_RosterFormRecord_form_table_shiftTitle"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("Tabler", {
                                                attrs: {
                                                  headers: _vm.shiftHeaders,
                                                  items: _vm.ShiftList,
                                                  border: "",
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "item.shift_name",
                                                    fn: function (ref) {
                                                      var item = ref.item
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "balck--text table-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$getCommonLangValue(
                                                                    item.shift_name
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "item.shift_time",
                                                    fn: function (ref) {
                                                      var item = ref.item
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "balck--text table-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$timeMachine(
                                                                    item.start_utc_time
                                                                  ) +
                                                                    " - " +
                                                                    _vm.$timeMachine(
                                                                      item.end_utc_time
                                                                    )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "item.action",
                                                    fn: function (ref) {
                                                      var item = ref.item
                                                      return [
                                                        _vm.iSEdited
                                                          ? _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  icon: "",
                                                                  small: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onDelete(
                                                                        "shift",
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons-round",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "delete"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                              }),
                                              _c(
                                                "v-sheet",
                                                { staticClass: "px-4" },
                                                [
                                                  _vm.iSEdited
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "text-capitalize",
                                                          attrs: {
                                                            text: "",
                                                            small: "",
                                                            color: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onNew(
                                                                "shift"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "label_essweb_RosterFormRecord_form_table_newShiftLabel"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "material-icons-round",
                                                            },
                                                            [_vm._v("add")]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-tab-item",
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "pa-0 rounded-lg",
                                          attrs: { elevation: "0" },
                                        },
                                        [
                                          _c(
                                            "v-card-text",
                                            { staticClass: "pa-0 rounded-lg" },
                                            [
                                              _c(
                                                "v-container",
                                                {
                                                  staticClass:
                                                    "white pa-3 ma-0 rounded-lg",
                                                },
                                                [
                                                  _c("SpecialTable", {
                                                    staticClass:
                                                      "max-width mb-8",
                                                    attrs: {
                                                      isHead: false,
                                                      readonly: "",
                                                      title: _vm.$t(
                                                        "label_essweb_rosterFormRecord_form_list_generationTitle"
                                                      ),
                                                      headers: _vm.otherHeaders,
                                                      tableTitle: _vm.$t(
                                                        "label_essweb_rosterFormRecord_form_list_generationTitle"
                                                      ),
                                                      type: "other1",
                                                      newBtn: "",
                                                      items: _vm.GenerationList,
                                                    },
                                                  }),
                                                  _c("SpecialTable", {
                                                    staticClass:
                                                      "max-width mb-8",
                                                    attrs: {
                                                      isHead: false,
                                                      readonly: "",
                                                      title: _vm.$t(
                                                        "label_essweb_rosterFormRecord_form_list_submitTitle"
                                                      ),
                                                      headers: _vm.otherHeaders,
                                                      tableTitle: _vm.$t(
                                                        "label_essweb_rosterFormRecord_form_list_submitTitle"
                                                      ),
                                                      type: "other2",
                                                      items: _vm.SubmitList,
                                                      newBtn: "",
                                                    },
                                                  }),
                                                  _c(
                                                    "v-row",
                                                    { attrs: { dense: "" } },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            xs: "12",
                                                            sm: "12",
                                                            md: "12",
                                                            lg: "12",
                                                            cols: "12",
                                                          },
                                                        },
                                                        [
                                                          _c("AutoComplete", {
                                                            attrs: {
                                                              label:
                                                                "label_essweb_RosterPropertyGroup_list_title",
                                                              items:
                                                                _vm.RosterPropertyGroup,
                                                              "item-text":
                                                                "roster_property_group_name",
                                                              "item-value":
                                                                "uuid",
                                                              disabled: "",
                                                              rules:
                                                                _vm.$GetRules(
                                                                  [
                                                                    "_Require_Rules",
                                                                  ],
                                                                  [null]
                                                                ),
                                                              "hide-details":
                                                                "",
                                                              messages:
                                                                "View Property",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .RosterRecordData
                                                                  .roster_property_group_uuid,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.RosterRecordData,
                                                                    "roster_property_group_uuid",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "\n                            RosterRecordData.roster_property_group_uuid\n                          ",
                                                            },
                                                          }),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "text-capitalize pa-0",
                                                              attrs: {
                                                                text: "",
                                                                "x-small": "",
                                                                disabled:
                                                                  !_vm
                                                                    .RosterRecordData
                                                                    .roster_property_group_uuid,
                                                                color:
                                                                  "primary",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.showPropertyDialog = true
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "label_essweb_shift_form_dialog_viewPropertyLabel"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "content-2",
                      fn: function () {
                        return [
                          _c(
                            "v-card",
                            {
                              staticClass:
                                "fill-height max-width pa-0 elevation-0",
                            },
                            [
                              _c(
                                "v-card-text",
                                {
                                  staticClass:
                                    "fill-height max-width pa-2 pt-3",
                                },
                                [
                                  _c("RosterPlan", {
                                    attrs: {
                                      Roster_uuid: _vm.Roster_uuid,
                                      change: _vm.isChange,
                                      iSEdited: _vm.iSEdited,
                                      shiftList: _vm.ShiftList,
                                      startTime:
                                        _vm.RosterRecordData
                                          .roster_utc_start_date,
                                      endTime:
                                        _vm.RosterRecordData
                                          .roster_utc_end_date,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "tools-main",
            fn: function () {
              return [
                _c("normalDialog", {
                  attrs: {
                    deleteModel: "",
                    dialog: _vm.showDelete,
                    title: _vm.deleteTitle,
                  },
                  on: {
                    close: function ($event) {
                      _vm.showDelete = false
                    },
                    confirm: _vm.toDelete,
                  },
                }),
                _c("newShift", {
                  attrs: {
                    show: _vm.showEditShift,
                    curShiftList: _vm.curShiftList,
                  },
                  on: {
                    onSave: _vm.onSaveShift,
                    close: function ($event) {
                      _vm.showEditShift = false
                    },
                  },
                }),
                _c("newManager", {
                  attrs: {
                    show: _vm.showEditManager,
                    curManageList: _vm.curManageList,
                  },
                  on: {
                    onSave: _vm.onSaveManager,
                    close: function ($event) {
                      _vm.showEditManager = false
                    },
                  },
                }),
                _c("newStaff", {
                  attrs: {
                    show: _vm.showEditStaff,
                    curStaffList: _vm.curStaffList,
                  },
                  on: {
                    onSave: _vm.onSaveStaff,
                    close: function ($event) {
                      _vm.showEditStaff = false
                    },
                  },
                }),
                _c("viewPropertyGroup", {
                  attrs: {
                    show: _vm.showPropertyDialog,
                    group_uuid: _vm.RosterRecordData.roster_property_group_uuid,
                  },
                  on: {
                    closeDialog: function ($event) {
                      _vm.showPropertyDialog = false
                    },
                  },
                }),
                _c("selectSender", {
                  attrs: {
                    show: _vm.showSender,
                    staff_uuid: _vm.curStaff,
                    status: _vm.curStep,
                    uuid: _vm.Roster_uuid,
                  },
                  on: {
                    onSave: _vm.toSennderDelete,
                    need: function (sender) {
                      _vm.curSender = sender
                      _vm.needSender = false
                    },
                    noSender: function (no) {
                      _vm.noSender = no
                    },
                    close: function ($event) {
                      _vm.showSender = false
                    },
                  },
                }),
                _c("ExportIn", {
                  attrs: { show: _vm.showExportIn, curUuid: _vm.Roster_uuid },
                  on: {
                    close: function ($event) {
                      _vm.showExportIn = false
                    },
                    export: _vm.onExportEnd,
                  },
                }),
                _c("ExportOut", {
                  attrs: {
                    show: _vm.showExportOut,
                    curUuid: _vm.Roster_uuid,
                    startTime: _vm.RosterRecordData.roster_utc_start_date,
                    endTime: _vm.RosterRecordData.roster_utc_end_date,
                  },
                  on: {
                    export: _vm.exportOut,
                    close: function ($event) {
                      _vm.showExportOut = false
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }